import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientCase } from "../../../context/diagnosticAgent";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import { AgePresenter } from "../common/agePresenter";
import { QualifiedFeatureListItemText } from "../common/qualifiedFeatureListItemText";
import { CaseGenderIcon } from "../common/caseGenderIcon";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { IconButton } from "@mui/material";
import EditIconSVGLight from "../../../assets/editIconLight.svg";
import EditIconSVG from "../../../assets/editIcon.svg";
import { useMemo } from "react";

//region [[ Styles ]]

const PatientChartAgeGenderHeaderView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingLeft: "8px",
  paddingTop: "10px",
  paddingRight: "8px",
  backgroundColor: KahunColorMap.PrimaryDim,
  marginBottom: "0px",
  position: "relative",
}));

const GenderContainer = styled("div")(({ theme }) => ({
  position: "relative",
}));

const AgeContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "10px",
  color: "white",
}));

const ChiefComplaintContainer = styled("div")(({ theme }) => ({
  display: "flex",
  marginTop: "-10px",
  justifyContent: "center",
  alignItems: "center",
  color: "white",

  width: "250px",

  "& .chief-complaint": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

const EditIconContainer = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: "13px",
  marginTop: "2px",
}));

const EditIconGender = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: "-5px",
  top: "43px",
  border: "1px solid " + KahunColorMap.Edit,
  padding: "5px",
  backgroundColor: "white",
}));

const EditText = styled("div")(({ theme }) => ({
  fontSize: "11px",
  fontWeight: 500,
  marginLeft: "3px",
  color: KahunColorMap.Edit,
}));

const EditIconStyled = styled("img")(({ theme }) => ({
  fontSize: "large",
  fill: KahunColorMap.Edit,
}));

const PatientListItem = styled("div")({
  display: "flex",
  marginTop: "8px",
  marginBottom: "8px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartAgeGenderHeaderProps {
  patientCase: PatientCase;
  onEditAge: () => void;
  onEditGender: () => void;
  onEditChiefComplaint: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientChartAgeGenderMobile = React.memo(
  ({ onEditAge, patientCase, ...props }: PatientChartAgeGenderHeaderProps) => {
    const agePresenter = useMemo(
      () => (
        <AgePresenter
          onClick={onEditAge}
          textSize={"small"}
          age={patientCase.age}
        />
      ),
      [onEditAge, patientCase],
    );
    return (
      <PatientChartAgeGenderHeaderView>
        <PatientListItem>
          <GenderContainer onClick={props.onEditGender}>
            <CaseGenderIcon
              onClick={props.onEditGender}
              gender={patientCase.gender}
            />
            <EditIconGender size={"small"}>
              <EditIconStyled src={EditIconSVG} alt={"Edit"} />
            </EditIconGender>
          </GenderContainer>

          <AgeContainer onClick={onEditAge}>
            <ListItemText primary={agePresenter} />
          </AgeContainer>

          <ChiefComplaintContainer onClick={props.onEditChiefComplaint}>
            <QualifiedFeatureListItemText
              hideRefinement={false}
              qualifiedFeature={patientCase.main}
              onEditFeature={props.onEditChiefComplaint}
              emptyText={"Add chief complaint"}
              className={"chief-complaint"}
              maxChars={85}
            />
            <EditIconContainer size={"small"}>
              <EditIconStyled src={EditIconSVGLight} alt={"Edit"} />
              <EditText>Edit</EditText>
            </EditIconContainer>
          </ChiefComplaintContainer>
        </PatientListItem>
      </PatientChartAgeGenderHeaderView>
    );
  },
);
